import { styled } from '@mui/material/styles'
import { ToggleButtonGroup } from '@mui/material'
import { GRAY_COLORS } from 'asterX-UI/colors.constant'

export const AsterToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  padding: 4,
  border: `1px solid ${GRAY_COLORS[200]}`,
  borderRadius: 8,
  gap: 4
}))
